import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { assetUrl, productImage } from "../api";

export default function ProductCard({ product }) {
  const { pathFor, t } = useLanguage();
  const [selectedColorId, setSelectedColorId] = useState(null);
  const colorOptions = useMemo(() => {
    const images = product.images || [];

    return (product.color || []).map((color) => ({
      ...color,
      productImage: images.find(
        (image) => String(image.color) === String(color.id),
      ),
    }));
  }, [product.color, product.images]);

  const selectedColor = colorOptions.find(
    (color) => String(color.id) === String(selectedColorId),
  );
  const selectedProductImage = selectedColor?.productImage;
  const displayedImage = selectedProductImage
    ? assetUrl(
        selectedProductImage.thumbnail_medium ||
          selectedProductImage.thumbnail_large ||
          selectedProductImage.image,
      )
    : productImage(product);
  const productHref = pathFor(
    `/products/${encodeURIComponent(product.spu)}/`,
  );

  return (
    <article className="product-card">
      <Link className="product-card-image" to={productHref}>
        <img src={displayedImage} alt={product.name || `${t("article")} ${product.spu}`} loading="lazy" />
        {product.is_made_in_italy && <img className="made-in-italy" src="/svg/made_in_italy.svg" alt="Made in Italy" />}
      </Link>
      <div className="product-card-body">
        <div className="swatches" aria-label={t("color")}>
          {colorOptions.map((color) => {
              const isSelected = String(color.id) === String(selectedColorId);
              return (
                <button
                  className={`swatch-button${isSelected ? " active" : ""}`}
                  data-color-id={color.id}
                  key={color.id}
                  type="button"
                  aria-label={`${t("color")}: ${color.name}`}
                  aria-pressed={isSelected}
                  disabled={!color.productImage}
                  onClick={() => setSelectedColorId(color.id)}
                  title={
                    color.productImage
                      ? color.name
                      : `${color.name} — image unavailable`
                  }
                >
                  {color.image ? (
                    <img src={assetUrl(color.image)} alt="" />
                  ) : (
                    <span
                      className="swatch-color"
                      style={{ backgroundColor: color.code || "#f2f2f2" }}
                    />
                  )}
                </button>
              );
            })}
          {colorOptions.length === 0 && <span />}
        </div>
        <p className="product-code">{t("article")} {product.spu}</p>
        <h3><Link to={productHref}>{product.name || product.spu}</Link></h3>
        <p className="product-price">{product.price ? `€${Number(product.price).toFixed(2)}` : t("priceOnRequest")}</p>
      </div>
    </article>
  );
}
